import React from "react";

/**
 * ApertureIris — stylised SVG iris that opens/closes with the f-stop.
 * Higher stops (larger f-number) => smaller opening.
 * Educational cue so students see WHY numbers like f/16 admit less light.
 */
const ApertureIris = ({ stops, size = 22 }) => {
    const cx = 10, cy = 10;
    const outerR = 9;
    // Map stops (1..8) to hole radius. f/1.4 → wide (~7), f/16 → pinhole (~1.2)
    const holeR = Math.max(1.2, 7.8 - stops * 0.85);

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            aria-hidden="true"
            data-testid="aperture-iris-svg"
        >
            {/* Lens body */}
            <circle cx={cx} cy={cy} r={outerR}
                    fill="rgba(255, 59, 0, 0.08)"
                    stroke="var(--amber)"
                    strokeWidth="0.9" />
            {/* Blades — polygons filling between the hole and the outer ring */}
            {[0, 60, 120, 180, 240, 300].map((deg) => {
                const rad = (deg * Math.PI) / 180;
                const nextRad = ((deg + 60) * Math.PI) / 180;
                const p1x = cx + Math.cos(rad) * holeR;
                const p1y = cy + Math.sin(rad) * holeR;
                const p2x = cx + Math.cos(nextRad) * outerR;
                const p2y = cy + Math.sin(nextRad) * outerR;
                const p3x = cx + Math.cos(rad) * outerR;
                const p3y = cy + Math.sin(rad) * outerR;
                return (
                    <polygon
                        key={deg}
                        points={`${p1x},${p1y} ${p2x},${p2y} ${p3x},${p3y}`}
                        fill="rgba(255, 59, 0, 0.55)"
                        stroke="var(--amber)"
                        strokeWidth="0.35"
                    />
                );
            })}
            {/* Central hole */}
            <circle cx={cx} cy={cy} r={holeR} fill="#000" />
        </svg>
    );
};

export default ApertureIris;
